import ajaxUtil from './ajax.js';
import moment from 'moment';
import URLParser from './url';

const M3U8Parser = require('m3u8-parser');
const {DOMAIN_CURRENT, ajaxv2} = ajaxUtil;

export const calBetweenTime = (item, time)=>{
  let result = Object.assign({}, item);

  if(result.startTime) {
    if(result.startTime.isAfter(time)) {
      result.startTime = time;
    }
  }else {
    result.startTime = time;
  }

  if(result.endTime) {
    if(time.isAfter(result.endTime)) {
      result.endTime = time;
    }
  }else {
    result.endTime = time;
  }

  return result;
};

export const m3u8Segments = (url, relative, extraOption)=>{
  return new Promise(resolve=>{
    let finalUrl = url;
    if(finalUrl && finalUrl.indexOf('http') < 0) {
      if(finalUrl.indexOf('rollback.jfoto.cn') < 0) {
        let array = relative.split('/');
        array.pop();
        array.push(finalUrl);

        finalUrl = array.join('/');
      }else {
        finalUrl = `http:${url}`;
      }
    }
    ajaxv2({
      url:'/api/util/proxy',
      method:'get',
      dataType:'json',
      data:{
        url:encodeURIComponent(finalUrl)
      }
    }).then(res=>{
      if(res) {
        var parser = new M3U8Parser.Parser();

        parser.push(res);
        parser.end();

        var parsedManifest = parser.manifest;
        const {segments} = parsedManifest;
        let item = {
          startTime:null,
          endTime:null,
          original:[],
          ...(extraOption)
        };
        (segments || []).forEach(it=>{
          let content = it.uri.match(/^(\d+)\_\d+([\.\-0-9]*).ts$/);
          if(content && content.length > 1) {
            let time = moment(content[1] * 1000);
            const startTimeResult = calBetweenTime({
              startTime:item.startTime,
              endTime:item.endTime
            }, moment(time.valueOf() - Number(it.duration) * 1000));

            const endTimeResult = calBetweenTime({
              startTime:item.startTime,
              endTime:item.endTime
            }, time);

            item.startTime = startTimeResult.startTime;
            item.endTime = endTimeResult.endTime;

            item.original.push(it);
          }
        });
        resolve(item);
      }
    })
  });
};

export const m3u8Parser = (source, url, extraOption, fixMode = false)=>{
  let result = {
    startTime:null,
    endTime:null,
    list:[],
    ...(extraOption)
  };
  return new Promise(resolve=>{
    if(source) {
      var parser = new M3U8Parser.Parser();

      parser.push(source);
      parser.end();

      var parsedManifest = parser.manifest;
      const {segments, playlists} = parsedManifest;

      if(playlists && playlists.length) {
        let promises = playlists.map(it=>{
          return m3u8Segments(it.uri, url, extraOption);
        });

        Promise.all(promises).then(array=>{
          (array || []).forEach(it=>{
            let {startTime, endTime} = it;
            let startResult = calBetweenTime({
              startTime:result.startTime,
              endTime:result.endTime
            }, startTime);

            let endResult = calBetweenTime({
              startTime:result.startTime,
              endTime:result.endTime
            }, endTime);

            result.startTime = startResult.startTime;
            result.endTime = endResult.endTime;

            result.list.push(it);
          });

          resolve(result);
        });
      }else if(segments && segments.length) {
        (segments || []).forEach(it=>{
          let content = it.uri.match(/^(\d+)\_\d+([\.\-0-9]*).ts$/);
          if(content && content.length > 1) {
            let time = moment(content[1] * 1000);
            const startTimeResult = calBetweenTime({
              startTime:result.startTime,
              endTime:result.endTime
            }, moment(time.valueOf() - Number(it.duration) * 1000));

            const endTimeResult = calBetweenTime({
              startTime:result.startTime,
              endTime:result.endTime
            }, time);

            result.startTime = startTimeResult.startTime;
            result.endTime = endTimeResult.endTime;

            result.list.push(it);
          }
        });

        if(fixMode) {
          let newResult = {
            ...result
          };
          newResult.list = [result];
          resolve(newResult);
        }else {
          resolve(result);
        }
      }else {
        resolve(result);
      }
    }else {
      resolve(null);
    }
  });
}



// WEBPACK FOOTER //
// ./src/util/video.js